module.exports = __webpack_public_path__ + "img/T4-A-xs_2.e1ae4303.png";